import { mutate } from 'swr';

import { publicConfig } from '@public-config';

import { Event } from 'models';

import { ApiService } from 'services/ApiService';
import { LocalStorageService } from 'services/LocalStorageService';
import { PayloadSDK } from 'services/PayloadSDK';

const EventService = {
    get: async (eventId: string) => {
        return await ApiService.get<Event>(`${publicConfig.urls.api}/events/${eventId}`);
    },

    getBySlug: async (slug: string, props?: { depth?: number }) => {
        const { depth = 0 } = props || {};

        const { docs } = await PayloadSDK.find({
            collection: 'events',
            where: { slug: { equals: slug } },
            limit: 1,
            depth,
        });

        return docs[0] as Event | undefined;
    },

    list: async ({ depth = 0 }: { depth?: number }) => {
        const result = await ApiService.get<{
            docs: Event[];
        }>(`${publicConfig.urls.api}/events?[sort]=-createdBy&limit=9999&depth=${depth}`);

        return {
            ...result,
            events: result.docs,
        };
    },

    getActiveEvents: async () => {
        const result = await ApiService.get<{
            docs: Event[];
        }>(`${publicConfig.urls.api}/events?where[isActive][equals]=true&depth=0`);

        return {
            ...result,
            events: result.docs,
        };
    },

    getDismissedEventSuggestions: () => {
        return LocalStorageService.get('dismissed-event-suggestions') || [];
    },

    dismissEventSuggestion: (suggestion: string) => {
        const suggestions = EventService.getDismissedEventSuggestions();
        suggestions.push(suggestion);

        LocalStorageService.store('dismissed-event-suggestions', suggestions);
    },

    update: async (eventId: string, payload: Partial<Event>) => {
        await ApiService.patch(`${publicConfig.urls.api}/events/${eventId}`, payload);
        await mutate('/api/events');
    },

    countProducts: async (eventId: string) => {
        return await ApiService.get<{
            total: number;
            counts: { manufacturer: string; productCount: number }[];
        }>(`${publicConfig.urls.api}/events/${eventId}/count-products`);
    },
};

export { EventService };
